import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Message } from '../Models/message';
import { User } from '../Models/user';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class MessageService {

  constructor(private http: HttpClient, private config: Config) { }

  list(user: User): Observable<Message[]> {

    return this.http.get<Message[]>(user._links.messages);
  }

  remove(msg: Message): any {

    return this.http.delete(msg._links.self);
  }

  markSeen(msg: Message): Observable<Message> {

    return this.http.post<Message>(msg._links.markseen, {});
  }

  markUnseen(msg: Message): Observable<Message> {

    return this.http.post<Message>(msg._links.markunseen, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/message.ts